import script from "./MRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./MRadioGroup.vue?vue&type=script&setup=true&lang=js"

import "./MRadioGroup.vue?vue&type=style&index=0&id=7c34f4be&lang=scss"

const __exports__ = script;

export default __exports__